function addCartPageFormEventListeners() {
  const mainCartForm = document.querySelector(
    'section#main-cart form[action$="/cart"]'
  )

  if (!mainCartForm) return null

  customInputNumberListeners(mainCartForm)
  handleQuantityButtons(mainCartForm, updateCartPage)
  handleCartAddFreeGift()
}

addCartPageFormEventListeners() //init on first page load

async function updateCartPage() {
  const res = await fetch('/?section_id=main-cart') //get section again that will contain the updated values
  const text = await res.text()

  //convert plain text to html
  const html = document.createElement('div')
  html.innerHTML = text

  //the whole section is replaced rather than just the cart form - the 'N Products'
  //count in the cart header sits outside the form, so replacing the form alone left
  //that count showing the quantity from before the update
  const selector = 'section#main-cart'
  const updatedCart = html.querySelector(selector).innerHTML
  document.querySelector(selector).innerHTML = updatedCart
  addCartPageFormEventListeners() //re-add event listeners once html has been replaced
}
